export default __webpack_public_path__ + "static/media/banner-logo.024e0207.svg";